import React, { createElement, forwardRef } from "react"
import { theme } from "antd"
import tw, { styled } from "twin.macro"
import { cssUnit, clsx } from "@/utilities/helper"
import Assets from "./icon.asset"

const Container = styled.div`
    ${(p) => p.$styles};
    display: block;
    opacity: ${(p) => p.$opacity};
    color: ${(p) => p.$color};
    width: ${(p) => cssUnit(p.$width)};
    height: ${(p) => cssUnit(p.$height)};
    cursor: ${(p) => p.$cursor};

    :hover {
        color: ${(p) => p.$hoveredColor};
    }

    svg {
        pointer-events: none;
    }
`

function AtomIcon(
    {
        name,
        onClick,
        sizes,
        size = 24,
        clickable = typeof onClick === "function",
        disabled,
        className,
        ...props
    },
    ref
) {
    const { token } = theme.useToken()

    const [component, styles] = Assets[name] || []
    const color = props.color ?? token.colorIcon
    const hoveredColor = props.hoveredColor ?? token.colorIconHover
    const disabledColor = props.disabledColor ?? color

    const renderSvgIcon = () => {
        if (component)
            return createElement(component, {
                style: { width: "inherit", height: "inherit" },
                className: clsx("atomic-svg-icon", `atomic-icon--${name}-inner`)
            })

        return <div />
    }

    return (
        <Container
            {...props}
            ref={ref}
            $width={sizes?.[0] ?? size}
            $height={sizes?.[1] ?? size}
            $styles={styles}
            $opacity={disabled ? 0.3 : 1}
            $cursor={disabled ? "not-allowed" : clickable ? "pointer" : "default"}
            $color={disabled ? disabledColor : color}
            $hoveredColor={
                disabled ? disabledColor : clickable || hoveredColor ? hoveredColor : color
            }
            className={clsx("atomic-icon", `atomic-icon--${name}`, className)}
            css={[!clickable && tw`pointer-events-none`, tw`transition-colors`]}
            onClick={(e) => !disabled && onClick?.(e)}
        >
            {renderSvgIcon()}
        </Container>
    )
}

export default forwardRef(AtomIcon)
export { Assets as AssetIcons }
